var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldLips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 780,
    viewBox: "0 0 1600 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95,
    filter: "url(#softGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 394C250 338 410 242 568 223C684 208 741 259 790 259C839 259 896 208 1012 223C1170 242 1330 338 1462 394",
    stroke: "url(#goldStroke)",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 394C253 434 405 515 575 538C681 552 744 488 790 488C836 488 899 552 1005 538C1175 515 1327 434 1448 394",
    stroke: "url(#goldStroke)",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78,
    filter: "url(#innerGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210 394C325 369 510 339 668 362C739 373 767 406 790 406C813 406 841 373 912 362C1070 339 1255 369 1370 394",
    stroke: "url(#goldStrokeSoft)",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 450C342 408 531 386 681 411C739 421 765 447 790 447C815 447 841 421 899 411C1049 386 1238 408 1332 450",
    stroke: "url(#goldStrokeSoft)",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.92
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270 419C354 386 528 369 681 389C741 397 768 422 790 422C812 422 839 397 899 389C1052 369 1226 386 1310 419",
    stroke: "url(#goldHighlight)",
    strokeWidth: 5,
    strokeLinecap: "round",
    opacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldStroke",
    x1: 118,
    y1: 223,
    x2: 1462,
    y2: 538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B430F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#B88724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E8B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#BD8C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C3608"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldStrokeSoft",
    x1: 210,
    y1: 362,
    x2: 1370,
    y2: 450,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#775718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EDCF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A4D10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldHighlight",
    x1: 270,
    y1: 392,
    x2: 1310,
    y2: 421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7AF4C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFF0C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7AF4C",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softGlow",
    x: 48,
    y: 149,
    width: 1484,
    height: 461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "innerGlow",
    x: 170,
    y: 326,
    width: 1240,
    height: 161,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.2,
    result: "blurInner"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blurInner"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldLips);
export default __webpack_public_path__ + "static/media/gold-lips.283a135151eb88e50d25f87b1d491637.svg";
export { ForwardRef as ReactComponent };